import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { CreatePromotionRequestDto, PromotionDto, UpdatePromotionRequestDto } from '../../dtos/promotion.dto';

@Injectable()
export class PromotionsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public list(organizationId: number): Observable<PromotionDto[]> {
    return this.http.get<PromotionDto[]>(`${this.apiUrl}${API_ENDPOINTS.promotions.list(organizationId)}`);
  }

  public getById(organizationId: number, promotionId: string): Observable<PromotionDto> {
    return this.http.get<PromotionDto>(`${this.apiUrl}${API_ENDPOINTS.promotions.byId(organizationId, promotionId)}`);
  }

  public create(organizationId: number, payload: CreatePromotionRequestDto): Observable<PromotionDto> {
    return this.http.post<PromotionDto>(`${this.apiUrl}${API_ENDPOINTS.promotions.list(organizationId)}`, payload);
  }

  public update(organizationId: number, promotionId: string, payload: UpdatePromotionRequestDto): Observable<PromotionDto> {
    return this.http.put<PromotionDto>(
      `${this.apiUrl}${API_ENDPOINTS.promotions.byId(organizationId, promotionId)}`, payload,
    );
  }

  public delete(organizationId: number, promotionId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${API_ENDPOINTS.promotions.byId(organizationId, promotionId)}`);
  }

  public duplicate(organizationId: number, promotionId: string): Observable<PromotionDto> {
    return this.http.post<PromotionDto>(
      `${this.apiUrl}${API_ENDPOINTS.promotions.duplicate(organizationId, promotionId)}`, {},
    );
  }
}
